import { LayoutConfig } from "../config/layout.config";
import { TenantDomainType } from "../enums/tenant-domain.enum";
import { TenantIdType } from "../enums/tenant-id.enum";
import { TenantNameTypeFull, TenantNameTypeShort, TenantTitleType } from "../enums/tenant-name.enum";

export class AssetHelper {
    domain = window.location.hostname;

    getFaviconByDomain() {
        switch (this.domain) {
            case TenantDomainType.CUDD: {
                return new LayoutConfig().cuddFavicon;
            }

            case TenantDomainType.TTS: {
                return new LayoutConfig().ttsFavicon;
            }

            default:
                return new LayoutConfig().defaultFavicon;
        }
    }

    getFaviconByTenant(tenantId: number) {
        switch (tenantId) {
            case TenantIdType.CUDD: {
                return new LayoutConfig().cuddFavicon;
            }

            case TenantIdType.TTS: {
                return new LayoutConfig().ttsFavicon;
            }

            default:
                return new LayoutConfig().defaultFavicon;
        }
    }

    getLogoByDomain() {
        switch (this.domain) {
            case TenantDomainType.CUDD: {
                return new LayoutConfig().cuddLogoLight;
            }

            case TenantDomainType.TTS: {
                return new LayoutConfig().ttsLogoLight;
            }

            default:
                return new LayoutConfig().defaultLogoLight;
        }
    }

    getLoaderByDomain() {
        switch (this.domain) {
            case TenantDomainType.CUDD: {
                return new LayoutConfig().getCuddConfigs.loader.enabled;
            }

            case TenantDomainType.TTS: {
                return new LayoutConfig().getTtsConfigs.loader.enabled;
            }

            default:
                return new LayoutConfig().getDefaultConfigs.loader.enabled;
        }
    }

    getShortNameByDomain() {
        switch (this.domain) {
            case TenantDomainType.CUDD: {
                return TenantNameTypeShort.CUDD;
            }

            case TenantDomainType.TTS: {
                return TenantNameTypeShort.TTS;
            }

            default:
                return TenantNameTypeFull.GENERIC;
        }
    }

    getShortNameByTenant(tenantId: number) {
        switch (tenantId) {
            case TenantIdType.CUDD: {
                return TenantNameTypeShort.CUDD;
            }

            case TenantIdType.TTS: {
                return TenantNameTypeShort.TTS;
            }

            default:
                return TenantNameTypeShort.GENERIC;
        }
    }

    getFullNameByDomain() {
        switch (this.domain) {
            case TenantDomainType.CUDD: {
                return TenantNameTypeFull.CUDD;
            }

            case TenantDomainType.TTS: {
                return TenantNameTypeFull.TTS;
            }

            default:
                return TenantNameTypeFull.GENERIC;
        }
    }

    getFullNameByTenant(tenantId: number) {
        switch (tenantId) {
            case TenantIdType.CUDD: {
                return TenantNameTypeFull.CUDD;
            }

            case TenantIdType.TTS: {
                return TenantNameTypeFull.TTS;
            }

            default:
                return TenantNameTypeFull.GENERIC;
        }
    }

    getTitleByDomain() {
        switch (this.domain) {
            case TenantDomainType.CUDD: {
                return TenantTitleType.CUDD;
            }

            case TenantDomainType.TTS: {
                return TenantTitleType.TTS;
            }

            default:
                return TenantTitleType.GENERIC;
        }
    }

    getTitleByTenant(tenantId: number) {
        switch (tenantId) {
            case TenantIdType.CUDD: {
                return TenantTitleType.CUDD;
            }

            case TenantIdType.TTS: {
                return TenantTitleType.TTS;
            }

            default:
                return TenantTitleType.GENERIC;
        }
    }
}